import styles from 'components/icons/Icon.module.scss';
import { IconProps } from 'components/icons/Icons.types';
import React from 'react';

const GearUserIcon: React.FC<IconProps> = ({
  className = '',
  size = 24,
  color = '#fffff0',
  fillColor = 'transparent',
  fillOpacity = 1,
  circleStrokeColor = '#fffff0',
}) => {
  const baseCls = `${styles.IconContainer} ${className}`;
  return (
    <div className={baseCls}>
      <svg width={size} height={size} viewBox="0 0 24 24" fill="transparent" xmlns="http://www.w3.org/2000/svg">
        <circle
          fill={fillColor}
          fillOpacity={fillOpacity}
          cx="12"
          cy="12"
          r="10.5"
          stroke={circleStrokeColor}
          strokeWidth={'1.5px'}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.75 17.07c-.5-.13-.95-.3-1.38-.52-.41-.23-.82-.54-1.21-.95l-2.32 1-.94-1.59 2.03-1.54c-.06-.26-.1-.52-.14-.76-.04-.25-.05-.49-.05-.73 0-.26.02-.51.05-.76s.08-.49.15-.73L4.89 8.96l.94-1.59 2.33.98c.39-.39.78-.7 1.21-.94.41-.24.89-.41 1.41-.52l.26-2.49h1.95l.28 2.52c.44.06.91.23 1.39.53s.86.6 1.15.94l2.4-.99.89 1.59-2.07 1.56c.05.27.09.52.13.74.05.23.06.46.06.73 0 .23-.02.46-.06.7s-.09.5-.15.77l2.05 1.54-.92 1.59-2.32-1.02c-.42.4-.83.7-1.22.93s-.84.4-1.31.52l-.34 2.57h-1.88Zm-1.08-2.34V12.54c0-.6.49-1.1 1.1-1.1h2.19c.6 0 1.1.49 1.1 1.1v2.19Zm3.42-4.89A1.21 1.21 90 0011.88 8.62a1.21 1.21 90 00-1.2 1.21 1.21 1.21 90 001.21 1.21 1.21 1.21 90 001.21-1.21Z"
          stroke={color}
          fill="none"
          strokeWidth={'1.25px'}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};

export default GearUserIcon;
